export default {
  path: 'new_tax_invoice',
  component: () => import('@/pages/newTaxInvoice/List'),
  meta: { title: '待开票账单' },
  children: [
    {
      path: 'apply',
      component: () => import('@/pages/newTaxInvoice/Apply'),
      meta: { title: '申请开票' }
    },
    {
      path: 'detail',
      component: () => import('@/pages/newTaxInvoice/Detail'),
      meta: { title: '发票详情' }
    }
  ]
}
